/**
 * path ของ shell เครื่องสแกน
 *
 * เก็บเป็นค่าคงที่เพราะใต้ `/scanner` มีมากกว่าหนึ่งหน้าจอแล้ว และผู้ที่ต้องอ้าง
 * เส้นเดียวกันมีสามฝั่ง: `App` ที่ลงทะเบียน route, หน้าจอที่ลิงก์หากัน และเทสต์
 * การพิมพ์สตริงซ้ำในสามที่คือวิธีที่ลิงก์กับ route หลุดจากกันโดยไม่มีใครเห็น
 *
 * ⚠️ ต้องไม่ทับ path ของ Desktop shell (D-037) — คนละ shell กัน และ
 * `desktop/routes.ts` มีเทสต์บังคับอยู่แล้วว่า path ของโมดูลห้ามขึ้นต้นด้วย
 * `/scanner`
 */

export const SCANNER_PATH = '/scanner';

/**
 * segment ของหน้าจอเปลี่ยนรหัสผ่าน — ใช้ลงทะเบียนเป็น route **ลูก** ของ
 * `SCANNER_PATH` เพื่อให้ด่านตรวจ token ของ shell เครื่องสแกนคุมมันด้วยเส้นเดียวกัน
 */
export const SCANNER_PASSWORD_SEGMENT = 'password';

/** URL เต็มของหน้าจอเปลี่ยนรหัสผ่านบนเครื่องสแกน */
export const SCANNER_PASSWORD_PATH = `${SCANNER_PATH}/${SCANNER_PASSWORD_SEGMENT}`;

/**
 * URL เต็มของโมดูลหนึ่งใต้เครื่องสแกน จาก `ScannerModeOption.path` (`modes.ts`)
 *
 * ที่ต้องมีฟังก์ชันนี้แทนการต่อสตริง `${SCANNER_PATH}/${segment}` กระจายอยู่ทั้ง
 * `App.tsx` (ลงทะเบียน route), `ScannerMenu.tsx` (ลิงก์ไปโมดูล) และ
 * `ScannerShell.tsx` (ปุ่มกลับเมนู/หาโมดูลปัจจุบันจาก URL) — สามที่นี้ต้องเห็นค่า
 * เดียวกันเสมอ (D-109 ข้อ 2)
 */
export function scannerModulePath(segment: string): string {
  return `${SCANNER_PATH}/${segment}`;
}
